<template>
  <div>
    <forgot-password-component
      v-if="step == 1"
      :is-loading="isLoading"
      @ForgotPassword="ForgotPassword"
    />
    <two-step-verification-component
      v-else-if="step == 2"
      :user-email="userEmail"
      :is-loading="isLoading"
      @TwoStepVerification="TwoStepVerification"
      @back="step = 1"
      @resend="resendCode"
    />
    <reset-password-component
      v-else-if="step == 3"
      :user-email="userEmail"
      :is-loading="isLoading"
      @updatePassword="updatePassword"
    />
  </div>
</template>

<script>
import axios from '@/component/axios'
import ForgotPasswordComponent from './ForgotPasswordComponent.vue'
import TwoStepVerificationComponent from './TwoStepVerificationComponent.vue'
import ResetPasswordComponent from './ResetPasswordComponent.vue'

export default {
  components: {
    ForgotPasswordComponent,
    TwoStepVerificationComponent,
    ResetPasswordComponent,
  },
  data() {
    return {
      userEmail: '',
      step: 1,
      isLoading: false,
      baseApi: process.env.VUE_APP_APIENDPOINT,
    }
  },
  methods: {
    authHeaders() {
      return { 'Content-Type': 'application/json' }
    },
    async ForgotPassword(userEmail) {
      this.userEmail = userEmail
      this.isLoading = true
      try {
        const res = await axios({
          method: 'POST',
          url: `${this.baseApi}auth/admin/reset-password-link`,
          headers: this.authHeaders(),
          data: { email: userEmail },
        })
        if (res.data.success) {
          this.step = 2
        } else {
          this.showError(res.data.message)
        }
      } catch (error) {
        this.showError(error.response?.data?.message || 'Unable to send reset code.')
      } finally {
        this.isLoading = false
      }
    },
    async resendCode() {
      if (!this.userEmail) {
        this.step = 1
        return
      }
      await this.ForgotPassword(this.userEmail)
      this.$swal({
        title: 'Code resent',
        text: 'A new verification code has been sent to your email.',
        icon: 'success',
        timer: 3000,
        showConfirmButton: false,
      })
    },
    async TwoStepVerification(otp) {
      this.isLoading = true
      try {
        const res = await axios({
          method: 'POST',
          url: `${this.baseApi}auth/admin/verify-otp`,
          headers: this.authHeaders(),
          data: { email: this.userEmail, otp },
        })
        if (res.data.success) {
          await this.$swal({
            title: 'Email Verified',
            text: 'Your email has been verified. You can now set a new password.',
            icon: 'success',
            confirmButtonText: 'Continue',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          })
          this.step = 3
        } else {
          this.showError(res.data.message)
        }
      } catch (error) {
        this.showError(error.response?.data?.message || 'Invalid verification code.')
      } finally {
        this.isLoading = false
      }
    },
    async updatePassword(password, cPassword) {
      this.isLoading = true
      try {
        const res = await axios({
          method: 'PUT',
          url: `${this.baseApi}auth/admin/reset-password`,
          headers: this.authHeaders(),
          data: {
            email: this.userEmail,
            new_password: password,
            confirm_password: cPassword,
          },
        })
        if (res.data.success) {
          await this.$swal({
            title: 'Success',
            text: res.data.message || 'Password updated successfully.',
            icon: 'success',
            confirmButtonText: 'Back to login',
            customClass: { confirmButton: 'btn btn-success' },
            buttonsStyling: false,
          })
          this.$router.push('/login')
        } else {
          this.showError(res.data.message)
        }
      } catch (error) {
        this.showError(error.response?.data?.message || 'Unable to reset password.')
      } finally {
        this.isLoading = false
      }
    },
    showError(message) {
      this.$swal({
        title: 'Error',
        timer: 5000,
        text: message || 'Something went wrong.',
        icon: 'error',
        customClass: { confirmButton: 'btn btn-danger' },
        buttonsStyling: false,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
